import { useEffect } from "react"
import inMemoryJWT from "../../auth/inMemoryJwt"

export const useTokenCallback = (fn,deps,cleaner)=>{
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            fn()
        })
        return ()=>{
            if(cleaner){
                cleaner()
            }
           
        }

    }, deps)
}